import fr from 'facet-rest';

export const FacetPlanAccount = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
  });
